/**
 * Serviço de integração com o Form-Handler da Agência Tatikka.
 */

const WORKER_URL = "https://form-handler.tatikka.workers.dev/";

export interface FormSubmissionData {
  formId: "daneluci_contato" | "daneluci_newsletter";
  name?: string;
  email: string;
  phone_number?: string;
  message?: string;
  [key: string]: any;
}

/**
 * Envia dados de formulário para o Worker central.
 */
export const sendToFormHandler = async (data: FormSubmissionData) => {
  try {
    const response = await fetch(WORKER_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Erro na resposta do servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Erro ao enviar formulário:", error);
    throw error;
  }
};
